import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { CAQuestion } from 'src/app/core-module/models/ExternalAudits/ca-question';

@Component({
    selector: 'app-text',
    templateUrl: './text.component.html',
    styleUrl: './text.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TextComponent {
public currentValue: string = '';
  @Input() currentQuestion:CAQuestion;
  @Output() currentQuestionChange = new EventEmitter<CAQuestion>();
  
  ngOnChanges(){
    this.validateIncomingValue(this.currentQuestion.AnswerText);
  }

  validateIncomingValue(value: string) {
    if (value == null) {
      this.currentValue = '';
    } else {
      this.currentValue = <string>value;
    }
  }
  updateCurrentAnswer() {
    this.currentQuestion.AnswerText = this.currentValue;
    this.validateAnswered();
    this.currentQuestionChange.emit(this.currentQuestion);
  }
  updateNA(){
    this.currentQuestion.NASelected = !this.currentQuestion.NASelected;
    if(this.currentQuestion.NASelected){
      this.currentQuestion.IsAnswered = true;
    }else{
      this.validateAnswered()
    }
  }
  validateAnswered(){
    if(this.currentQuestion.AnswerText.length>0 || this.currentQuestion.NASelected){
      this.currentQuestion.IsAnswered = true;
    }else{
      this.currentQuestion.IsAnswered = false;
    }
  }
}
